module.exports = __webpack_public_path__ + "img/icon_enjoy06@2x.7b3cb82a.png";